import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  TextField,
} from "@material-ui/core";
import classNames from "classnames";

import { DialogTitle } from "../core";

// context
import { useSnackbar } from "notistack";
import { useUserState } from "../../context/UserContext";
import { useCollectionDispatch } from "../../context/CollectionContext";

import { createCollection } from "../../clientAPI";
import { useVideoCollections } from "../../useGlobal";

const useStyles = makeStyles(theme =>
  createStyles({
    dialogPaper: {
      padding: theme.spacing(1),
      width: 440,
      borderRadius: 10,
    },
    dialogTitle: {
      ...theme.typography.h6,
      fontWeight: 500,
      color: "black",
    },
    dialogDescription: {
      ...theme.typography.smallCaption,
    },
    dialogButton: {
      ...theme.typography.subtitle2,
      fontWeight: 500,
    },
    actionContainer: {
      display: "flex",
      justifyContent: "space-around",
    },
    actionBack: {
      flex: "0 1 auto",
    },
    actionConfirm: {
      color: "white",
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      width: 71,
      height: 32,
      padding: "4px 21px",
      borderRadius: 20,
    },
    submit: {
      display: "flex",
      flex: "1 0 auto",
      justifyContent: "flex-end",
    },
  }),
);

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const CollectionCreateDialog = ({ open, setOpen, videoId }) => {
  const classes = useStyles();
  const { isAuthenticated } = useUserState();
  const { enqueueSnackbar } = useSnackbar();

  const collectionDispatch = useCollectionDispatch();
  const { videoCollections, setVideoCollections } = useVideoCollections(
    videoId,
    isAuthenticated,
  );

  const [titleValue, setTitleValue] = useState("");

  const handleDialogClose = () => {
    if (setOpen) {
      setOpen(false);
    }
    collectionDispatch({
      type: "CREATE_COLLECTION_DONE",
    });
  };

  return (
    <div>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleDialogClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle id='alert-dialog-slide-title' onClose={handleDialogClose}>
          新增資料夾
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id='alert-dialog-slide-description'
            className={classes.dialogDescription}
          >
            請於以下欄位輸入資料夾名稱。
          </DialogContentText>
          <TextField
            id={"create-title"}
            variant='outlined'
            label='名稱'
            value={titleValue}
            onChange={e => setTitleValue(e.target.value)}
            inputProps={{ maxLength: 10 }}
            margin='normal'
            fullWidth
          />
        </DialogContent>
        <DialogActions className={classes.actionContainer}>
          <Button
            onClick={handleDialogClose}
            color='primary'
            className={classNames(classes.dialogButton, classes.actionBack)}
          >
            返回
          </Button>
          <div className={classes.submit}>
            <Button
              color='primary'
              className={classNames(
                classes.dialogButton,
                classes.actionConfirm,
              )}
              onClick={() => {
                createCollection(titleValue)
                  .then(data => {
                    setVideoCollections(
                      {
                        video_id: videoCollections.video_id,
                        collections: [
                          ...videoCollections.collections,
                          { ...data, cid: data.id, collected: true },
                        ],
                      },
                      true,
                    );
                    handleDialogClose();
                  })
                  .catch(err => {
                    console.log(err);
                    enqueueSnackbar("建立失敗", { variant: "error" });
                  });
              }}
            >
              確定
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

CollectionCreateDialog.defaultProps = {};

CollectionCreateDialog.propsTypes = {};

export default CollectionCreateDialog;
